import { useAdminConfig, useUpsertAdminConfig } from "@/hooks/useAdminConfig";

/**
 * Default terminology map — orgs can override any of these labels.
 * Keys are internal identifiers; values are the display strings.
 */
const DEFAULTS: Record<string, string> = {
  committee: "Team",
  committees: "Teams",
  committee_member: "Team Member",
  committee_members: "Team Members",
  volunteer: "Volunteer",
  volunteers: "Volunteers",
  chair: "Chair",
  sponsor_tier_label: "Sponsorship Level",
};

export const useTerminology = () => {
  const { data: config, isLoading } = useAdminConfig("terminology");
  const upsert = useUpsertAdminConfig();

  const overrides = (config as Record<string, string> | null) || {};

  /** Get the org-customized label for a terminology key */
  const t = (key: keyof typeof DEFAULTS): string => {
    return overrides[key] || DEFAULTS[key];
  };

  /** Save new terminology overrides */
  const save = (values: Partial<typeof DEFAULTS>) => {
    return upsert.mutateAsync({
      config_key: "terminology",
      config_value: { ...overrides, ...values },
    });
  };

  return { t, save, overrides, defaults: DEFAULTS, isLoading, isSaving: upsert.isPending };
};
